import type { ScreenContext } from "~/services/aiOrchestrator";
import type { WalkthroughAvailabilityState } from "~/walkthroughs/types";

import Config from "~/config";
import { labelForPath } from "~/helpers/aiChat/fernieFeedback";
import i18n from "~/i18n/i18n";
import { findWalkthroughsForRoute } from "~/walkthroughs/registry";

const buildScreenContext = (route: string, state: WalkthroughAvailabilityState): ScreenContext => {
	const screenLabel = labelForPath(route);
	const availableWalkthroughs = findWalkthroughsForRoute(route, state).map((walkthrough) => ({
		id: walkthrough.id,
		title: i18n.t(walkthrough.titleKey)
	}));
	return {
		...(Config.buildVersion ? { appVersion: Config.buildVersion } : {}),
		route,
		...(screenLabel ? { screenLabel } : {}),
		...(availableWalkthroughs.length > 0 ? { availableWalkthroughs } : {})
	};
};

export { buildScreenContext };
export default buildScreenContext;
